<template>
  <button type="button" @click="click" class="rounded-md disabled:cursor-not-allowed border text-sm font-medium h-fit "
    :class="config[type]" :disabled="disabled">
    <span v-if="loading">
      <span class="inline-flex items-center space-x-2">
        <p>{{ loadingText }}</p>
        <LoadingCircle class="h-4 w-4" />
      </span>
    </span>
    <span v-else>
      <div class="flex flex-row justify-center items-center px-4 py-2 space-x-2">
        <slot name="left"></slot>
        <p class="text-base">{{ text }}</p>
        <slot name="right"></slot>
      </div>

    </span>
  </button>
</template>

<script>

export default {
  name: 'Button',
  props: {
    /** Indica si el botón está en estado activo, y se puede clickear */
    disabled: { type: Boolean, default: false },

    /** Indica si el boton está en estado loading */
    loading: { type: Boolean, default: false },

    /** Indica el texto si loading = true */
    loadingText: { type: String, required: false },

    /** Indica el texto del botón */
    text: { type: String, required: false },

    /** Indica el tipo de botón */
    type: { type: String, default: 'primary' },
  },

  data() {
    return {
      config: {
        primary: 'bg-colescba-blue-600 text-white  hover:enabled:bg-colescba-blue-500 focus:border-blue-300 disabled:opacity-50 disabled:bg-gray-100 disabled:text-gray-700 disabled:border-gray-300 ',
        secondary: 'bg-white border-blue-brand-500 text-blue-brand-500 hover:bg-blue-brand-100 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-blue-brand-300 hover:text-blue-brand-500 active:text-blue-brand-500 disabled:opacity-50 disabled:bg-gray-100 disabled:text-gray-700 disabled:border-gray-300',
        cancel: 'border-gray-300 bg-white text-gray-700 hover:enabled:bg-cool-gray-100 focus:enabled:border-blue-300  disabled:text-gray-500 disabled:bg-gray-100 disabled:border-gray-300 disabled:opacity-50 ',
        danger: 'bg-red-600 text-white disabled:text-gray-700 border border-gray-300 disabled:border-gray-300 disabled:bg-gray-100  hover:enabled:bg-red-500 focus:border-red-300'
      }
    }
  },
  methods: {
    click(e) {
      e.preventDefault()
      this.$emit('click')
    },
  },

}
</script>
